import { PetCustomReminderModel } from '@common/models/PetCustomReminders';
import { stringDateToISODate } from '@common/utils';
import { observer } from 'mobx-react'
import React from 'react'
import { Button, Table } from 'react-bootstrap';

interface IThirdPartyRemindersTableProps {
    remindersAdded: PetCustomReminderModel[];
    setActiveReminder: (value: PetCustomReminderModel) => void;
    onSelectedToRemind: () => void;
    removeReminder: (salesItemOptionId: number) => void;
}

export const ThirdPartyRemindersTable = observer(({ remindersAdded, setActiveReminder, onSelectedToRemind, removeReminder }: IThirdPartyRemindersTableProps) => {
    const onRemind = (reminder: PetCustomReminderModel) => {
        setActiveReminder(reminder);
        onSelectedToRemind();
    }

    return (
        <Table hover striped size="sm">
            <thead>
                <tr>
                    <th>Description</th>
                    <th className='ps-2'>Status</th>
                    <th className='ps-2'>Actions</th>
                </tr>
            </thead>
            <tbody>
                {
                    _.isEmpty(remindersAdded)
                        ?
                        <>
                            <tr>
                                <td>No reminders added.</td>
                                <td></td>
                                <td></td>
                            </tr>
                        </>
                        :
                        <>
                            {remindersAdded.map((reminder, idx) =>
                                <tr key={`reminder-${idx}-row`}>
                                    <td>
                                        <div className='d-flex flex-column gap-1'>
                                            {reminder.salesItemName}
                                            {
                                                reminder.reminded &&
                                                <div className='d-flex flex-column' style={{ paddingLeft: "2rem", fontSize: "smaller" }}>
                                                    <p className='attributes-title'>Due Date: <span className='attributes-desc'>{stringDateToISODate(reminder.dueDate)}</span></p>
                                                    <p className='attributes-title'>Source: <span className='attributes-desc'>{reminder.reminderSourceName}</span></p>
                                                </div>
                                            }
                                        </div>
                                    </td>
                                    <td>
                                        <Button
                                            variant='outline-primary'
                                            className={reminder.reminded ? 'exam-item-added' : 'exam-item-add'}
                                            onClick={() => onRemind(reminder)}>{reminder.reminded ? 'Reminded' : 'Remind'}
                                        </Button>
                                    </td>
                                    <td><Button variant='outline-primary' onClick={() => removeReminder(reminder.salesItemOptionId)}>Remove</Button></td>
                                </tr>)
                            }
                        </>
                }
            </tbody>
        </Table >
    )
});
